"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var antd_1 = require("antd");
var ToolBarButtonsOnly_1 = require("../../../../../../../../shared/components/toolbars/ToolBarButtonsOnly");
var ToolBarDateRangeFilter_1 = require("../../../../../../../../shared/components/toolbars/ToolBarDateRangeFilter");
var TournamentSessionGameLogList = /** @class */ (function (_super) {
    __extends(TournamentSessionGameLogList, _super);
    function TournamentSessionGameLogList(props) {
        var _this = _super.call(this, props) || this;
        _this.columns = [
            {
                title: 'Игрок',
                dataIndex: _this.props.dataLogs.dk_usr_player_login,
                key: _this.props.dataLogs.dk_usr_player_login,
                width: 200,
            }, {
                title: 'Бренд',
                dataIndex: _this.props.dataLogs.dk_brand_title,
                key: _this.props.dataLogs.dk_brand_title,
                width: 200,
            }, {
                title: 'Валюта',
                dataIndex: _this.props.dataLogs.dk_app_currency_title,
                key: _this.props.dataLogs.dk_app_currency_title,
                width: 100,
            }, {
                title: 'Сумма',
                dataIndex: _this.props.dataLogs.dk_bet_amount,
                key: _this.props.dataLogs.dk_bet_amount,
                width: 200,
            }, {
                title: 'Тип',
                dataIndex: _this.props.dataLogs.dk_bet_type_title,
                key: _this.props.dataLogs.dk_bet_type_title,
                width: 100,
            }, {
                title: 'Игра',
                dataIndex: _this.props.dataLogs.dk_gws_gameprovider_game_title,
                key: _this.props.dataLogs.dk_gws_gameprovider_game_title,
                width: 200,
            }, {
                title: 'Раунд',
                dataIndex: _this.props.dataLogs.dk_round_id,
                key: _this.props.dataLogs.dk_round_id,
                width: 100,
            }, {
                title: 'Добавлено',
                dataIndex: _this.props.dataLogs.dk_date_added,
                key: _this.props.dataLogs.dk_date_added,
                render: function (text, record, idx) {
                    return (React.createElement("div", null, record.date_added.format(_this.state.dtFormat)));
                },
                width: 200,
            }
        ];
        return _this;
    }
    TournamentSessionGameLogList.prototype.getDataOffset = function () {
        return (this.state.pageNum - 1) * this.state.pageSize;
    };
    TournamentSessionGameLogList.prototype.componentWillMount = function () {
        var _this = this;
        this.SID = this.props.dataLogs.Subscribe("*", function (id, data) {
            _this.setState({
                data: data.data,
                totalRows: data.total
            });
        });
        this.SID_STATE = this.props.state.Subscribe("*", function (id, data) {
            _this.setState({
                dtFrom: data.dtFrom,
                dtTo: data.dtTo,
                dtFormat: data.dtTimeFormat,
            }, function () {
                _this.loadData(_this.props);
            });
        });
        this.setState({
            data: [],
            pageNum: 1,
            pageSize: this.props.state.getTablePageSize(),
            totalRows: 0,
            dtFrom: this.props.state.getDateFrom(),
            dtTo: this.props.state.getDateTo(),
            dtFormat: this.props.state.getDateTimeFormat()
        }, function () {
            _this.loadData(_this.props);
        });
    };
    TournamentSessionGameLogList.prototype.componentWillUnmount = function () {
        this.props.dataLogs.UnSubscribe(this.SID);
        this.props.state.UnSubscribe(this.SID_STATE);
    };
    /*public componentWillReceiveProps(nextProps: TournamentSessionGameLogListProps) {
        if (nextProps) {
            this.setState({
                pageNum: nextProps.pageNum,
                pageSize: nextProps.pageSize,
            }, () => {
                this.loadData(nextProps);
            });
        }
    }*/
    TournamentSessionGameLogList.prototype.loadData = function (Props, onDone) {
        Props.dataLogs.LoadRangeData({
            tournamentSessionId: Props.session.key,
            from_year: this.state.dtFrom.get('year'),
            from_month: this.state.dtFrom.get('month') + 1,
            from_day: this.state.dtFrom.get('date'),
            from_hour: this.state.dtFrom.get('hour'),
            from_minute: this.state.dtFrom.get('minute'),
            to_year: this.state.dtTo.get('year'),
            to_month: this.state.dtTo.get('month') + 1,
            to_day: this.state.dtTo.get('date'),
            to_hour: this.state.dtTo.get('hour'),
            to_minute: this.state.dtTo.get('minute'),
            offset: this.getDataOffset(),
            limit: this.state.pageSize
        }, function () {
            if (onDone) {
                onDone();
            }
        });
    };
    TournamentSessionGameLogList.prototype.onPageChanged = function (Page, PageSize) {
        var _this = this;
        var _page = Page;
        if (PageSize != this.state.pageSize) {
            _page = 1;
        }
        this.setState({ pageNum: _page, pageSize: PageSize }, function () {
            _this.loadData(_this.props, function () {
                //if (this.props.onPageConfigChanged) {
                //    this.props.onPageConfigChanged(_page, PageSize);
                //}
            });
        });
    };
    TournamentSessionGameLogList.prototype.onToolBarClick = function (action) {
        if (action === "refresh") {
            this.loadData(this.props);
        }
        if (action === "create") {
        }
        if (action === "back") {
            if (this.props.onGoBackClick) {
                this.props.onGoBackClick();
            }
        }
    };
    TournamentSessionGameLogList.prototype.onSelectRange = function (DtFrom, DtTo) {
        this.props.state.setDateFrom(DtFrom).setDateTo(DtTo, true);
    };
    TournamentSessionGameLogList.prototype.render = function () {
        var _this = this;
        return (React.createElement("div", null,
            React.createElement(ToolBarButtonsOnly_1.default, { hint: { refresh: "Обновить", back: "Назад" }, onClick: this.onToolBarClick.bind(this) },
                React.createElement(ToolBarDateRangeFilter_1.default, { title: "\u0414\u0438\u0430\u043F\u0430\u0437\u043E\u043D \u0434\u0430\u0442: ", from: { date: this.state.dtFrom, title: "Начало" }, to: { date: this.state.dtTo, title: "Окончание" }, onClick: this.onSelectRange.bind(this) })),
            React.createElement(antd_1.Table, { locale: {
                    filterTitle: 'Поиск',
                    filterConfirm: 'Да',
                    filterReset: 'Сброс',
                    emptyText: 'Нет данных',
                }, bordered: true, columns: this.columns, dataSource: this.state.data, pagination: {
                    pageSize: this.state.pageSize,
                    showSizeChanger: true,
                    current: this.state.pageNum,
                    total: this.state.totalRows,
                    position: "bottom",
                    onChange: this.onPageChanged.bind(this),
                    onShowSizeChange: this.onPageChanged.bind(this),
                    pageSizeOptions: this.props.state.UITablePageSizeOptions,
                    showQuickJumper: true,
                }, footer: function (data) {
                    return React.createElement("div", null,
                        "\u041E\u0442\u043E\u0431\u0440\u0430\u0436\u0430\u0435\u0442\u0441\u044F \u043D\u0430 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0435 : ",
                        data.length,
                        " \u0438\u0437 ",
                        _this.state.totalRows,
                        " \u0437\u0430\u043F\u0438\u0441\u0435\u0439");
                }, expandedRowRender: function (record) {
                    return (React.createElement("div", null,
                        React.createElement("div", null,
                            React.createElement("b", null, "\u0418\u0434\u0435\u043D\u0442\u0438\u0444\u0438\u043A\u0430\u0442\u043E\u0440 \u0437\u0430\u043F\u0438\u0441\u0438:"),
                            " [",
                            record.key,
                            "] "),
                        React.createElement("div", null,
                            React.createElement("b", null, "\u0421\u043E\u0437\u0434\u0430\u043D:"),
                            " [",
                            record.date_added.format(_this.state.dtFormat),
                            "] "),
                        React.createElement("div", null,
                            React.createElement("b", null, "\u0418\u0433\u0440\u043E\u043A:"),
                            " [",
                            record.usr_player_login,
                            "]"),
                        React.createElement("div", null,
                            React.createElement("b", null, "\u0428\u043B\u044E\u0437:"),
                            " [",
                            record.gws_gameprovider_title,
                            "]"),
                        React.createElement("div", null,
                            React.createElement("b", null, "\u0411\u0430\u043B\u0430\u043D\u0441 \u0441\u0435\u0441\u0441\u0438\u0438 \u0434\u043E:"),
                            " [",
                            record.tournament_balance_before,
                            "]"),
                        React.createElement("div", null,
                            React.createElement("b", null, "\u0411\u0430\u043B\u0430\u043D\u0441 \u0441\u0435\u0441\u0441\u0438\u0438 \u043F\u043E\u0441\u043B\u0435:"),
                            " [",
                            record.tournament_balance_after,
                            "]"),
                        React.createElement("div", null,
                            React.createElement("b", null, "\u0414\u0435\u0439\u0441\u0442\u0432\u0438\u0435:"),
                            " [",
                            record.action_type,
                            "]")));
                }, scroll: { x: true } })));
    };
    return TournamentSessionGameLogList;
}(React.Component));
exports.default = TournamentSessionGameLogList;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/gift_tournament/ui/component/options/game_logs/TournamentSessionGameLogList.tsx
// module id = 2528
// module chunks = 0